$(function () {
  $('a[href^="#"]').click(function () {
    let speed = 500
    let href = $(this).attr("href")
    let target = $(href == "#" || href == "" ? 'html' : href)
    let position = target.offset().top - 130
    $("html, body").animate({ scrollTop: position }, speed, "swing")
    return false
  })

  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    $('.effect-fade').each(function () {
      var elemPos = $(this).offset().top
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-scroll')
      }
    })
  })

  var topSplide = new Splide('.top__splide', {
    type: 'loop',
    padding: '22%',
    focus: 'center',
    pagination: false,
    gap: '13px',
    perPage: 1,
    arrows: false,
  })

  topSplide.mount()

  var chooseSplide = new Splide('.choose__splide', {
    type: 'loop',
    padding: '7%',
    focus: 'center',
    pagination: false,
    gap: '36px',
    updateOnMove: true,
    perPage: 3,
    breakpoints: {
      879: {
        padding: '34%',
        gap: '13%',
        perPage: 1,
        pagination: true,
      },
    },
  })

  chooseSplide.mount()

  // 連動させる要素を取得
  const chooseItems = document.querySelectorAll('.js-choose-item')

  // 移動が始まった瞬間に実行
  chooseSplide.on('move', (newIndex) => {
    // すべての要素から表示クラスを消す
    chooseItems.forEach(item => item.classList.remove('is-visible'))

    // 新しいインデックス（newIndex）の要素に表示クラスをつける
    // ループ設定の場合、indexの扱いに注意が必要ですが、
    // chooseSplide.on('move') の newIndex はスライドの純粋な番号を返します。
    if (chooseItems[newIndex]) {
      chooseItems[newIndex].classList.add('is-visible')
    }
  })
})